interface Props {
  text: string;
  disabled?: boolean;
  icon?: boolean
  type: 'submit' | 'button';
  rest?: any;
}

export default function SubmitButton({ text, disabled, icon=false, type, ...rest }: Props) {

  return (
    <button
      disabled={disabled}
      {...rest}
      type={type}
      className={`hover:bg-[#333] focus:outline-[#FF609E] focus:outline-4  w-full mt-[16px] cursor-pointer inline-flex flex-row justify-center text-center rounded-full py-[12px] px-[28px] text-text-center text-white bg-black ${disabled ? 'opacity-50 cursor-not-allowed' : ''} text-[16px]`}
    >
      {text} {icon && <img src="/right-arrow.svg" alt="Arrow Right" className="ml-2 h-4 w-4 my-auto" />}
    </button>
  )

}
